export default __webpack_public_path__ + "static/media/screen6.fa9121d9.jpg";